<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-12 mb-primary">
				<div class="card card-with-shadow border-0 h-100">
					<div class="card-header p-primary bg-transparent">
						<h5 class="card-title m-0">Migration Status</h5>
					</div>
					<app-overlay-loader v-if="preloader" />
					<div class="card-body">
						<form
							ref="form"
							data-url="/transaction/customer"
							class="mb-0"
							:class="{ 'loading-opacity': preloader }"
						>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label> CLC ID Number </label>
										<app-input
											type="advance-search-select"
											:loaded-per-time="10"
											v-model="input_lead_id"
											@input="setLeadIdValue"
											:fetch-url="'transaction/lead?clc_id_number_operator=!=&clc_id_number=null&sub_status_id_operator=!=&sub_status_id=13'"
											placeholder="CLC ID Number"
											list-value-field="clc_id_number"
										/>
									</div>
								</div>
							</div>

							<div class="mt-5 action-buttons">
								<button
									type="submit"
									class="btn btn-primary mr-2"
									@click.prevent="submit"
								>
									{{ $t("submit") }}
								</button>
								<button
									type="submit"
									class="btn btn-secondary"
									@click.prevent="clear"
								>
									{{ $t("clear") }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

export default {
	name: "MigrationStatus",
	mixins: [FormMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					product_category_id: undefined,
					code: "",
					name: "",
					is_active: "",
					product_category: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				lead_id: undefined,
			},
			input_lead_id: this.value
				? this.value.lead
					? {
							id: this.value.lead.id || 0,
							full_name: this.value.lead.full_name || "",
					  }
					: {
							id: this.value.lead?.id || 0,
							full_name: this.value.lead?.full_name || "",
					  }
				: {
						id: this.value.lead.id || 0,
						full_name: this.value.lead.full_name || "",
				  },
		};
	},
	methods: {
		beforeSubmit() {
			this.preloader = true;
		},
		submit() {
			this.save(this.inputs);
		},

		afterSuccess(res) {
			this.$toastr.s(res.data.message);
		},
		afterFinalResponse() {
			this.preloader = false;
			this.inputs = {};
		},
		afterError(res) {
			this.$toastr.e(res.data.message);
		},
		clear() {
			this.inputs = {};
			this.input_lead_id = {
				id: undefined,
				full_name: "",
			};
			this.fieldStatus = {
				isSubmit: false,
			};
		},
		setLeadIdValue(data) {
			this.inputs.lead_id = this.inputs.lead_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.lead_id = data.id;
			}
		},
	},
};
</script>

<style scoped>
.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
